// Internal components
import Loader from '../Loader/Loader'

const FallbackLoader = () => {
  return (
    <div className="FallbackLoader">
      <Loader />
    </div>
  )
}

export default FallbackLoader
